import React from 'react';
import ReverseIntegrationLayout from '../../base/components/reverse-integration/common-layout';

const ReverseIntegrationList = () => <ReverseIntegrationLayout />;

export default ReverseIntegrationList;
